export function maskEmail(email) {
    const [local, domain] = email.split('@');
    if (!local || !domain) {
        return email;
    }
    if (local.length <= 2) {
        return `${local[0]}*@${domain}`;
    }
    return `${local[0]}${'*'.repeat(local.length - 2)}${local[local.length - 1]}@${domain}`;
}
export function maskPhone(phone) {
    const digits = phone.replace(/\D/g, '');
    const last4 = digits.slice(-4);
    return `(***) ***-${last4}`;
}
export const COUNTRY_CODES = [
    { value: '+1', label: 'US/CA +1' },
    { value: '+20', label: 'EG +20' },
    { value: '+27', label: 'ZA +27' },
    { value: '+30', label: 'GR +30' },
    { value: '+31', label: 'NL +31' },
    { value: '+32', label: 'BE +32' },
    { value: '+33', label: 'FR +33' },
    { value: '+34', label: 'ES +34' },
    { value: '+36', label: 'HU +36' },
    { value: '+39', label: 'IT +39' },
    { value: '+40', label: 'RO +40' },
    { value: '+41', label: 'CH +41' },
    { value: '+43', label: 'AT +43' },
    { value: '+44', label: 'UK +44' },
    { value: '+45', label: 'DK +45' },
    { value: '+46', label: 'SE +46' },
    { value: '+47', label: 'NO +47' },
    { value: '+48', label: 'PL +48' },
    { value: '+49', label: 'DE +49' },
    { value: '+51', label: 'PE +51' },
    { value: '+52', label: 'MX +52' },
    { value: '+54', label: 'AR +54' },
    { value: '+55', label: 'BR +55' },
    { value: '+56', label: 'CL +56' },
    { value: '+57', label: 'CO +57' },
    { value: '+60', label: 'MY +60' },
    { value: '+61', label: 'AU +61' },
    { value: '+62', label: 'ID +62' },
    { value: '+63', label: 'PH +63' },
    { value: '+64', label: 'NZ +64' },
    { value: '+65', label: 'SG +65' },
    { value: '+66', label: 'TH +66' },
    { value: '+7', label: 'RU +7' },
    { value: '+81', label: 'JP +81' },
    { value: '+82', label: 'KR +82' },
    { value: '+84', label: 'VN +84' },
    { value: '+86', label: 'CN +86' },
    { value: '+90', label: 'TR +90' },
    { value: '+91', label: 'IN +91' },
    { value: '+92', label: 'PK +92' },
    { value: '+94', label: 'LK +94' },
    { value: '+98', label: 'IR +98' },
    { value: '+234', label: 'NG +234' },
    { value: '+351', label: 'PT +351' },
    { value: '+353', label: 'IE +353' },
    { value: '+358', label: 'FI +358' },
    { value: '+420', label: 'CZ +420' },
    { value: '+886', label: 'TW +886' },
    { value: '+966', label: 'SA +966' },
    { value: '+971', label: 'AE +971' },
    { value: '+972', label: 'IL +972' },
    { value: '+974', label: 'QA +974' },
    { value: '+994', label: 'AZ +994' },
    { value: '+995', label: 'GE +995' },
    { value: '+998', label: 'UZ +998' },
];
